import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { FilterName } from '../../../../store/models/filter.model';
import { parseChipsInputBulkDataEntry, removeInputElement } from '../../../../common/utils/helpers';
import { DialogSize } from '../../../../common/constants/dialog-config';
import { IconNames } from '../../../../common/constants/icon-names';
import { MatChipsReportColumnsDialogComponent } from '../mat-chips-report-columns-dialog/mat-chips-report-columns-dialog.component';
import { DraggableFilterType } from '../../../../store/constants';
import { ProfileReport, ProfileReportItem } from '../../../../store/models';
import { SvgIconComponent } from '../../../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-monitoring-report-item',
  templateUrl: './monitoring-report-item.component.html',
  styleUrls: ['./monitoring-report-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatFormFieldModule, MatChipsModule, SvgIconComponent],
})
export class MonitoringReportItemComponent {
  @Input() filterSelectOptionsByName: Map<FilterName, string[]>;
  @Input() reportFormControl: UntypedFormControl;
  @Input() type: DraggableFilterType;
  @Input() name: FilterName;
  @Input() label: string;
  @Input() reportItemList: ProfileReportItem[];
  @Input() removable: boolean;
  @Input() isDisabled!: boolean;
  @Input() maxFieldsCount: number;

  iconNameList = IconNames;

  removeFilter: (control: UntypedFormControl | UntypedFormGroup, element: string) => void = removeInputElement;

  constructor(public cd: ChangeDetectorRef, private dialog: MatDialog) {}

  addElement(
    control: UntypedFormControl | AbstractControl,
    input: HTMLInputElement,
    inputControl: UntypedFormControl,
  ): void {
    parseChipsInputBulkDataEntry(control, input, inputControl);
  }

  openFilterDialog(
    filterName: string,
    label: string,
    filtersFormControlOrGroup: UntypedFormControl | UntypedFormGroup,
  ): void {
    if (!this.removable || this.isDisabled) {
      return;
    }
    const reportItemList = this.reportItemList;
    const dialogRef = this.dialog.open(MatChipsReportColumnsDialogComponent, {
      width: DialogSize.XL,
      data: {
        filterName,
        label,
        filtersFormControlOrGroup,
        reportItemList,
        maxFieldsCount: this.maxFieldsCount,
      },
    });

    dialogRef.afterClosed().subscribe((event: { selectedItems: ProfileReport[] }) => {
      if (event?.selectedItems?.length) {
        this.reportFormControl.setValue(event?.selectedItems);
        this.reportFormControl.markAsDirty();
      }
    });
  }
}
